import React from "react";

/**
 * SelectInput component
 *
 * Props:
 *  - label?: string
 *  - name: string
 *  - value: string | number
 *  - onChange: (e) => void
 *  - options: { label: string; value: string | number }[]
 *  - required?: boolean
 *  - disabled?: boolean
 */
export function SelectInput({
  label,
  name,
  value,
  onChange,
  options,
  required = false,
  disabled = false,
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed transition-colors"
        required={required}
        disabled={disabled}
      >
        <option value="">{`— Select —`}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}